<template>
    <form :action="route('my_time_submit')" method="post">
    
    <div class="row">
        <div class="col-9">
            <div class="page-title-box">
                <h4 class="page-title">
                    My Time
                </h4>
            </div>
        </div>
        <div class="col-3">
            <div class="page-title-box">
                <form action="" id="select_week_form">
                    <input placeholder="Select Week" type="date" name="select_week" class="form-control mt-4" id="select_week" @change="selectedWeek">
                </form>
            </div>
        </div>
    </div>     
    <!-- end page title --> 

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">

                    <div class="table-responsive">
                        <table class="table table-centered dt-responsive nowrap w-100" id="products-datatable">
                            <thead>
                                <tr>
                                    <th>Project</th>
                                    <th>Budget</th>
                                    <th>Booked Total</th>

                                    <th v-for="day in week_days" :key="day">
                                        {{ formatDate(day) }}
                                    </th>
                                    <th>Week total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="project in projects" :key="project.id">
                                    <th scope="row">{{ project.project_name }}</th>
                                    <td>{{ project.effort }}</td>
                                    <td>{{ project.days }}</td>
                                    <td v-for="day in week_days" :key="day">
                                        <input
                                        type="number"
                                        class="form-control my-time-input"
                                        :name="'my_hours[' + day + '][' + project.id + '][hours]'"
                                        :value="(my_hours[day] && my_hours[day][project.id] ? my_hours[day][project.id].hours : 0)"
                                        >

                                        <div class="time-comment" @click="openComments(day, my_hours[day], project.id, project.project_name)">
                                            <i v-if="my_hours[day] && my_hours[day][project.id] && my_hours[day][project.id].comments.length > 0" class="uil-comment-alt-verify has-comment"  title="Comments"></i>
                                            <i v-else class="uil-comment-alt-medical no-comment" title="Add comment"></i>
                                        </div>

                                        <input
                                        type="hidden"
                                        :name="'my_hours[' + day + '][' + project.id + '][id]'"
                                        :value="(my_hours[day] && my_hours[day][project.id] ? my_hours[day][project.id].id : '')">
                                    </td>
                                    <td>
                                        {{ getTotalWeek(my_hours, project.id) }}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Admin/Office
                                    </th>
                                    <td></td>
                                    <td></td>
                                    <td v-for="day in week_days" :key="day">
                                        <input
                                        type="number"
                                        class="form-control my-time-input"
                                        :name="'my_hours[' + day + '][admin][hours]'"
                                        :value="(my_hours[day] && my_hours[day].admin ? my_hours[day].admin.hours : 0)"
                                        >

                                        <div class="time-comment" @click="openComments(day, my_hours[day], 'admin', 'Admin')">
                                            <i v-if="my_hours[day] && my_hours[day].admin && my_hours[day].admin.comments.length > 0" class="uil-comment-alt-verify has-comment"  title="Comments"></i>
                                            <i v-else class="uil-comment-alt-medical no-comment" title="Add comment"></i>
                                        </div>

                                        <input
                                        type="hidden"
                                        :name="'my_hours[' + day + '][admin][id]'"
                                        :value="(my_hours[day] && my_hours[day].admin ? my_hours[day].admin.id : '')">
                                    </td>
                                    <td>
                                        {{ getTotalWeek(my_hours, 'admin') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Vacation
                                    </th>
                                    <td></td>
                                    <td></td>
                                    <td v-for="day in week_days" :key="day">
                                        <input
                                        type="number"
                                        class="form-control my-time-input"
                                        :name="'my_hours[' + day + '][vacation][hours]'"
                                        :value="(my_hours[day] && my_hours[day].vacation ? my_hours[day].vacation.hours : 0)"
                                        >

                                        <div class="time-comment" @click="openComments(day, my_hours[day], 'vacation', 'Vacation')">
                                            <i v-if="my_hours[day] && my_hours[day].vacation && my_hours[day].vacation.comments.length > 0" class="uil-comment-alt-verify has-comment"  title="Comments"></i>
                                            <i v-else class="uil-comment-alt-medical no-comment" title="Add comment"></i>
                                        </div>

                                        <input
                                        type="hidden"
                                        :name="'my_hours[' + day + '][vacation][id]'"
                                        :value="(my_hours[day] && my_hours[day].vacation ? my_hours[day].vacation.id : '')">
                                    </td>
                                    <td>
                                        {{ getTotalWeek(my_hours, 'vacation') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-1">
            <input type="hidden" name="_token" :value="csrf">
            <button type="submit" class="btn btn-success ml-5">Save</button>
        </div>
    </div>
    </form>

    <!-- Modal comments -->
    <div 
        class="modal fade"
        id="commentsModal"
        tabindex="-1"
        aria-labelledby="comments"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="comments">
                        Comments for {{ modalDay }} in {{ modalTitle }}
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">

                    <div class="row p-2">

                        <div class="row col-md-12 single-comment mt-3" v-for="(comment, commentKey) in activeDay.comments" :key="commentKey">
                            <div class="col-md-9">
                                {{ comment.comment }}
                            </div>
                            <div class="col-md-3">
                                <div class="circular" :title="comment.user.name">
                                    <img v-if="comment.user.image" class="profile-image" :src="'/' + comment.user.image" alt="">
                                    <img v-else class="profile-image" src="/images/team-placeholder.png" alt="">
                                </div>
                                <br>
                                <span>
                                    {{ formatDateHours(comment.created_at) }}
                                </span>
                            </div>
                        </div>

                    </div>

                    <div class="row p-2">

                        <div class="col-md-12 add-comment mt-3">
                            <label for="new-comment-textarea" class="form-label">Add Comment</label>
                            <form action="/my-time-submit" method="post">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="hidden" name="user_project_time_id" v-model="newCommentTimeID">
                                <input type="hidden" name="user_project_id" v-model="newCommentProjectID">
                                <input type="hidden" name="user_project_time_day" v-model="newCommentTimeDay">

                                <textarea class="form-control form-control-light mb-2" name="new_comment" v-model="newComment" placeholder="Write comment" id="new-comment-textarea" rows="3"></textarea>
                                <div class="text-end">
                                    <!--<div class="btn-group mb-2">
                                        <button type="button" class="btn btn-link btn-sm text-muted font-18"><i class="dripicons-paperclip"></i></button>
                                    </div>-->
                                    <div class="btn-group mb-2 ms-2">
                                        <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        
                    </div>

                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>



<script>

import Main from "@/Layouts/Main.vue";
import Pagination from "@/Components/Pagination.vue";
import moment from 'moment';
import { Modal } from 'bootstrap';

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        projects: Array,
        week_days: Array,
        my_hours: Array,
        users: Array,
        customers: Array,
        flash: Object,
    },
    components: {
        Pagination,
    },
    data() {
        return {
            modal: null,
            csrf: '',
            activeDay: [],
            modalTitle: '',
            modalDay: '',
            newCommentTimeID: null,
            newCommentTimeDay: null,
            newCommentProjectID: null
        };
    },
    methods: {
        formatDate (date) {
            return moment(date).format('Do MMM YYYY')
        },
        formatDateHours (date) {
            return moment(date).format('Do MMM YYYY, HH:mm')
        },
        openComments(day, hours, id, modalTitle) {
            this.activeDay = (hours && hours[id] ? hours[id] : [])
            this.newCommentTimeID = (hours && hours[id] ? hours[id].id : null)
            this.newCommentTimeDay = day
            this.newCommentProjectID = id

            this.modalDay = this.formatDate(day)
            this.modalTitle = modalTitle
            this.modal.show();
        },
        selectedWeek () {
            const form = document.getElementById("select_week_form");
            form.submit(); // This submits the form
        },
        getTotalWeek (hours, id) {

            let totalHours = 0
            for (const day in hours) {
                if (hours.hasOwnProperty(day)) {
                    const element = hours[day];
                    if (element[id]) {
                        totalHours += element[id].hours;
                    }
                }
            }
            return totalHours;

        }
    },

    computed: {
        deleteConfirmation() {
            return `Are you sure went to delete ${this.project.name}?`;
        },
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);
        this.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

        var modalEl = document.getElementById('commentsModal')
        this.modal = new Modal(modalEl)

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>

<style scoped>
    .time-comment {
        font-size: 24px;
        cursor: pointer;
        display:inline-block;
    }

    .no-comment {
        color: #c22222;
    }
    .has-comment {
        color: #28a614;
    }

    .my-time-input {
        max-width:70px;
        display:inline-block;
    }

    .single-comment {
        padding: 13px 3px;
        border: 1px solid #e2e2e2;
        border-radius: 5px;
        margin-left: 0;
    }

    .add-comment {
        padding: 13px 3px;
        margin-left: 0;
    }
</style>
